import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">话题热度</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热点话题</h2>
          <p className="mt-2 text-foreground-600 text-sm">当前黑料网站社区最受关注的话题标签</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#"
              className="group relative bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer text-center"
            >
              {topic.hot && (
                <span className="absolute -top-2 -right-2 px-1.5 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full flex items-center gap-0.5">
                  <i className="ri-fire-line text-[9px]"></i>热
                </span>
              )}
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {topic.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500">{topic.count}讨论</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}